import { const_var, params } from "../../redux/reducers/reducer";
import { calcOverhangSize } from "../building_component/buildingComponent.helper";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../redux/reducers/utils";
import { makeDimensionArray } from "../building/building_style/centreBuilding.helper";
import { calculateLegsCount, updateBreezewayFrameAndStorages } from "../common/common.helper";
import { deleteInsulationKeysForLeanTo } from "../lean_building_pricing/lean_building_wall/leanBuildingWall.helper";
export const updateOverHang = (action, state) => {
	const obj = const_var.ExtraItemsFeaturesArray;
	const a_p_d_a = const_var.a_p_d_a;
	let item = obj[action.index];
	if (item?.is_checked) {
		item.is_checked = !obj[action.index].is_checked;
		item.cost = action.nextVal.cost;
	} else {
		item = JSON.parse(JSON.stringify(action.nextVal));
		item.is_checked = true;
	}
	item.is_edit = false;
	item.quantity = item.is_checked == true ? 1 : 0;
	if (item.is_checked) {
		state.const_var.extraItemsFeaturesCost[action.index] = action.nextVal.cost;
	}
	if (!item.is_checked) {
		item.cost = state.const_var.extraItemsFeaturesCost[action.index] ?? item.cost;
	}
	item.cost ??= 0;
	if (action.indexName == "overhang") {
		const overhang = state.const_var.isOverhang;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		if (const_var.isWainscotManualPriceUpdate != true) {
			const_var.UpdatedPriceData.wainscot_price_changed = true;
		}
		if (action.nextVal.sheet_type == "both") {
			overhang["end"]["size"] = item.is_checked == true ? 1 : 0.5;
			overhang["side"]["size"] = item.is_checked == true ? 1 : 0.5;
			overhang["both"]["size"] = item.is_checked == true ? 1 : 0.5;
			overhang["both"]["selected"] = item.is_checked;

			state.params.o_v_h_n_g = item.is_checked;
			state.params.o_v_h_n_g_e = item.is_checked;
		} else {
			overhang[action.nextVal.sheet_type]["selected"] = a_p_d_a.overhang[action.nextVal.sheet_type][0].sheet_name;
			overhang[action.nextVal.sheet_type]["isChecked"] = item.is_checked;
			let size = calcOverhangSize(overhang[action.nextVal.sheet_type]["selected"]);
			overhang[action.nextVal.sheet_type]["size"] = item.is_checked == true ? size : 0.5;
			if (action.nextVal.sheet_type == "side") {
				state.params.o_v_h_n_g = item.is_checked;
			} else {
				state.params.o_v_h_n_g_e = item.is_checked;
			}
		}
		cuBuilding.BuildingUpdate(true, "");
		if (params.add_front_lean == true) cuBuilding.UpdateFrontLean(params.add_front_lean);
		if (params.add_left_lean == true) cuBuilding.UpdateLeftLean(params.add_left_lean);
		if (params.add_right_lean == true) cuBuilding.UpdateRightLean(params.add_right_lean);
		if (params.add_back_lean == true) cuBuilding.UpdateBackLean(params.add_back_lean);
	}
	const_var.ExtraItemsFeaturesArray[action.index] = item;
	state.const_var.ExtraItemsFeaturesArray[action.index] = item;
};
export const handleOverHang = (action, state) => {
	const a_p_d_a = JSON.parse(JSON.stringify(const_var.holdPricingResponse));
	state.const_var.isOverhang[action.isfor]["isChecked"] = !state.const_var.isOverhang[action.isfor]["isChecked"];
	if (action.isfor == "side") {
		state.params.o_v_h_n_g = state.const_var.isOverhang[action.isfor]["isChecked"];
	}
	if (action.isfor == "end") {
		state.params.o_v_h_n_g_e = state.const_var.isOverhang[action.isfor]["isChecked"];
	}
	if (action.isfor == "both") {
		state.params.o_v_h_n_g = state.const_var.isOverhang[action.isfor]["isChecked"];
		state.params.o_v_h_n_g_e = state.const_var.isOverhang[action.isfor]["isChecked"];

		state.const_var.isOverhang["both"]["size"] = 1;
		state.const_var.isOverhang["side"]["size"] = 1;
		state.const_var.isOverhang["end"]["size"] = 1;

		state.const_var.isOverhang["both"]["selected"] = "";
		state.const_var.isOverhang["side"]["selected"] = "";
		state.const_var.isOverhang["end"]["selected"] = "";
	}
	if (action.isfor != "both") {
		state.const_var.isOverhang[action.isfor]["selected"] = a_p_d_a.overhang[action.isfor][0].sheet_name;

		let size = calcOverhangSize(state.const_var.isOverhang[action.isfor]["selected"]);
		state.const_var.isOverhang[action.isfor]["size"] = size;

		if (state.const_var.isOverhang[action.isfor]["isChecked"] == true) {
			let objIndex = -1;
			state.const_var.ExtraItemsFeaturesArray.length > 0 &&
				state.const_var.ExtraItemsFeaturesArray.some((key, value) => {
					if (key != null && key.sheet_type != undefined && key.sheet_type == action.isfor) {
						objIndex = value;
						return true;
					}
				});
			if (objIndex != -1) {
				let tempArray = [...state.const_var.ExtraItemsFeaturesArray];
				tempArray[objIndex] = {};
				state.const_var.ExtraItemsFeaturesArray = tempArray;
			}
		}
	}
	const_var.UpdatedPriceData.roof_color_price_changed = true;

	return {
		...state,
		action
	};
};
export const handleOverHangSelection = (action, state) => {
	state.const_var.isOverhang[action.isfor]["selected"] = action.value;

	let size = calcOverhangSize(state.const_var.isOverhang[action.isfor]["selected"]);
	state.const_var.isOverhang[action.isfor]["size"] = size;

	const_var.UpdatedPriceData.roof_color_price_changed = true;
	return {
		...state,
		action
	};
};
export const handleExtraElements = (state, action, utils, ManufacturesDefaultDetails) => {
	let reRenderVar = "";
	if (action.condition == "jtrim") {
		state.params.p_j_t = !state.params.p_j_t;
		reRenderVar = action.condition + state.params.p_j_t;
		state.const_var.UpdatedPriceData.common_length_changed = true;
	}
	if (action.condition == "end_jtrim") {
		state.params.p_j_t_end = !state.params.p_j_t_end;
		reRenderVar = action.condition + state.params.p_j_t_end;
		state.const_var.UpdatedPriceData.common_width_changed = true;
	}
	if (action.condition == "4feetcenter") {
		state.params.fourth_center_cost = !state.params.fourth_center_cost;
		reRenderVar = action.condition + state.params.fourth_center_cost;
		if (state.params.fourth_center_cost) {
			state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s] = 4;
			state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		} else {
			state.const_var.DistanceArr[state.params.p_b_t][state.params.p_r_s] = 5;
			state.params.p_u_t = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		}
		params.oncenter_val_with_action = "";
		params.oncenter_val = 0;
		cuBuilding.uUdDCB();

		cuBuilding.uUdD();
		cuBuilding.leanuUdD();
		cuBuilding.BuildingUpdate(true, "");
		if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
		if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
		if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
		if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
	}

	if (action.condition == "riskcategory") {
		state.params.risk_cost = !state.params.risk_cost;
		reRenderVar = action.condition + state.params.risk_cost;
	}
	if (action.condition == "certificatecost") {
		state.params.cert_pac_cost = !state.params.cert_pac_cost;
		reRenderVar = action.condition + state.params.cert_pac_cost;
	}
	if (action.condition == "groundcertificate") {
		state.params.p_g_c = !state.params.p_g_c;
		reRenderVar = action.condition + state.params.p_g_c;
	}
	if (action.condition == "overhang") {
		state.params.p_o_p = !state.params.p_o_p;
		reRenderVar = action.condition + state.params.p_o_p;
		if (const_var.UpdatedPriceData.common_length_changed != state.params.p_o_p) {
			state.const_var.UpdatedPriceData.common_length_changed = true;
		}
		const_var.UpdatedPriceData.roof_color_price_changed = true;
	}

	if (action.condition == "extraBracing") {
		state.params.p_b_p = !state.params.p_b_p;
		reRenderVar = action.condition + state.params.p_b_p;
	}
	if (action.condition == "insulation") {
		state.isShowOverlay = false;
		state.params.p_i_o = action.value;
		if (action.value != 0) state.params.selectedInsulationId = action.value;
		state.const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
		state.const_var.UpdatedPriceData.insulation_price_changed = true;
		state.const_var.UpdatedPriceData.insulation_price = undefined;

		reRenderVar = action;
	}

	if (action.condition == "noInsulation") {
		state.isShowOverlay = false;
		state.params.p_r_o = false;
		state.params.p_f_i = false;
		state.params.p_c_i = false;
		state.const_var.InsulationOnWall = {};
		state.const_var.thirdPartyComponent.tax.garage = {};
		state.const_var.thirdPartyComponent.tax.insulation = {};
		state.const_var.thirdPartyComponent.commissions.garage = {};
		state.const_var.thirdPartyComponent.commissions.insulation = {
			center: {},
			left: {},
			right: {},
			front: {},
			back: {}
		};
		state.const_var.thirdPartyComponent.surcharge.garage = {};
		state.const_var.thirdPartyComponent.surcharge.insulation = {
			center: {},
			left: {},
			right: {},
			front: {},
			back: {}
		};
		if (const_var.insulationPriceJson.insulation_wall != undefined) {
			const_var.insulationPriceJson.insulation_wall = {};
		}

		if (const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0) {
			deleteInsulationKeysForLeanTo();
		}

		if (params.add_front_lean) {
			if (const_var.leanGetDataFront && const_var.insulationArrayForLeantoFront.insulation_wall != undefined) {
				const_var.insulationArrayForLeantoFront.insulation_wall = {};
			}
			state.params.insulation.frontLean.fullBuilding = state.params.p_f_i;
			state.params.insulation.frontLean.roofOnly = state.params.p_r_o;
			state.params.insulation.frontLean.custom = state.params.p_c_i;
		}
		if (params.add_left_lean) {
			if (const_var.leanGetDataLeft && const_var.insulationArrayForLeantoLeft.insulation_wall != undefined) {
				const_var.insulationArrayForLeantoLeft.insulation_wall = {};
			}
			state.params.insulation.leftLean.fullBuilding = state.params.p_f_i;
			state.params.insulation.leftLean.roofOnly = state.params.p_r_o;
			state.params.insulation.leftLean.custom = state.params.p_c_i;
		}
		if (params.add_right_lean) {
			if (const_var.leanGetDataRight && const_var.insulationArrayForLeantoRight.insulation_wall != undefined) {
				const_var.insulationArrayForLeantoRight.insulation_wall = {};
			}
			state.params.insulation.rightLean.fullBuilding = state.params.p_f_i;
			state.params.insulation.rightLean.roofOnly = state.params.p_r_o;
			state.params.insulation.rightLean.custom = state.params.p_c_i;
		}
		if (params.add_back_lean) {
			if (const_var.leanGetDataBack && const_var.insulationArrayForLeantoBack.insulation_wall != undefined) {
				const_var.insulationArrayForLeantoBack.insulation_wall = {};
			}
			state.params.insulation.backLean.fullBuilding = state.params.p_f_i;
			state.params.insulation.backLean.roofOnly = state.params.p_r_o;
			state.params.insulation.backLean.custom = state.params.p_c_i;
		}

		if (params.add_front_lean && state.params.insulation.frontLean.insulationId != 0) {
			state.params.insulation.frontLean.insulationId = 0;
			const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
		}
		if (params.add_left_lean && state.params.insulation.leftLean.insulationId != 0) {
			state.params.insulation.leftLean.insulationId = 0;
			const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
		}
		if (params.add_right_lean && state.params.insulation.rightLean.insulationId != 0) {
			state.params.insulation.rightLean.insulationId = 0;
			const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
		}
		if (params.add_back_lean && state.params.insulation.backLean.insulationId != 0) {
			state.params.insulation.backLean.insulationId = 0;
			const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
		}

		state.params.p_i_o = 0;
		state.params.selectedInsulationId = state.params.p_i_o;
		state.const_var.showDefaultInsullation = false;
		state.const_var.UpdatedPriceData.insulation_price = undefined;
		state.const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
	}
	let isInsulationCanApplied = true;
	if (ManufacturesDefaultDetails.AMERICAN_STEEL_CARPORTS.id == params.selectedManufactureId && action.condition == "roofOnly" && state.params.p_r_s != 3) {
		isInsulationCanApplied = false;
	} else if (
		ManufacturesDefaultDetails.AMERICAN_STEEL_CARPORTS.id == params.selectedManufactureId &&
		(action.condition == "fullBuilding" || action.condition == "custom") &&
		(state.params.p_r_s != 3 ||
			(!state.params.p_v_w && state.params.p_r_s == 3) ||
			(state.params.p_v_w &&
				state.params.p_r_s == 3 &&
				state.params.p_f_w.toLowerCase() == "open" &&
				state.params.p_b_w.toLowerCase() == "open" &&
				state.params.p_l_w.toLowerCase() == "open" &&
				state.params.p_r_w.toLowerCase() == "open"))
	) {
		isInsulationCanApplied = false;
	} else {
		isInsulationCanApplied = true;
	}
	if (!isInsulationCanApplied) {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "notAllowInsulationForHorizontalOrRegularRoof";
		reRenderVar = action;
	} else {
		if (action.condition == "roofOnly") {
			state.params.p_r_o = !state.params.p_r_o;
			state.params.p_f_i = false;
			state.params.p_c_i = false;
			state.const_var.InsulationOnWall = {};

			if (const_var.insulationPriceJson.insulation_wall != undefined) {
				const_var.insulationPriceJson.insulation_wall = {};
			}

			if (const_var.post_data?.building?.leanto?.length > 0) {
				deleteInsulationKeysForLeanTo();
			}

			if (params.add_front_lean) {
				if (const_var.leanGetDataFront && const_var.insulationArrayForLeantoFront.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoFront.insulation_wall = {};
				}
				state.params.insulation.frontLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.frontLean.roofOnly = state.params.p_r_o;
				state.params.insulation.frontLean.custom = state.params.p_c_i;
			}
			if (params.add_left_lean) {
				if (const_var.leanGetDataLeft && const_var.insulationArrayForLeantoLeft.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoLeft.insulation_wall = {};
				}
				state.params.insulation.leftLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.leftLean.roofOnly = state.params.p_r_o;
				state.params.insulation.leftLean.custom = state.params.p_c_i;
			}
			if (params.add_right_lean) {
				if (const_var.leanGetDataRight && const_var.insulationArrayForLeantoRight.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoRight.insulation_wall = {};
				}
				state.params.insulation.rightLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.rightLean.roofOnly = state.params.p_r_o;
				state.params.insulation.rightLean.custom = state.params.p_c_i;
			}
			if (params.add_back_lean) {
				if (const_var.leanGetDataBack && const_var.insulationArrayForLeantoBack.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoBack.insulation_wall = {};
				}
				state.params.insulation.backLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.backLean.roofOnly = state.params.p_r_o;
				state.params.insulation.backLean.custom = state.params.p_c_i;
			}

			reRenderVar = action;
			if (state.params.p_r_o == false) {
				state.params.p_i_o = 0;
				if (const_var.a_p_d_a && const_var.cbInsulation != undefined && const_var.cbInsulation.length > 0) {
					state.params.insulation.frontLean.insulationId = 0;
					state.params.insulation.leftLean.insulationId = 0;
					state.params.insulation.rightLean.insulationId = 0;
					state.params.insulation.backLean.insulationId = 0;
				}
				state.const_var.showDefaultInsullation = false;
			}
			if (state.params.p_i_o == 0) {
				state.params.p_i_o = Object.keys(const_var.insulationJson)[0];

				if (const_var.a_p_d_a && const_var.cbInsulation != undefined && const_var.cbInsulation.length > 0) {
					if (params.add_front_lean) {
						state.params.insulation.frontLean.insulationId = state.params.p_i_o;
					}
					if (params.add_left_lean) {
						state.params.insulation.leftLean.insulationId = state.params.p_i_o;
					}
					if (params.add_right_lean) {
						state.params.insulation.rightLean.insulationId = state.params.p_i_o;
					}
					if (params.add_back_lean) {
						state.params.insulation.backLean.insulationId = state.params.p_i_o;
					}
				}
			}
			state.const_var.UpdatedPriceData.insulation_price = undefined;
			state.const_var.UpdatedPriceData.insulation_price_changed = true;
			const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
			state.params.selectedInsulationId = state.params.p_i_o;
		}
		if (action.condition == "fullBuilding") {
			state.params.p_f_i = !state.params.p_f_i;
			state.params.p_r_o = false;
			state.params.p_c_i = false;
			state.const_var.InsulationOnWall = {};

			if (const_var.insulationPriceJson.insulation_wall != undefined) {
				const_var.insulationPriceJson.insulation_wall = {};
			}

			if (const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0) {
				deleteInsulationKeysForLeanTo();
			}

			if (params.add_front_lean) {
				if (const_var.leanGetDataFront && const_var.insulationArrayForLeantoFront.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoFront.insulation_wall = {};
				}
				state.params.insulation.frontLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.frontLean.roofOnly = state.params.p_r_o;
				state.params.insulation.frontLean.custom = state.params.p_c_i;
			}
			if (params.add_left_lean) {
				if (const_var.leanGetDataLeft && const_var.insulationArrayForLeantoLeft.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoLeft.insulation_wall = {};
				}
				state.params.insulation.leftLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.leftLean.roofOnly = state.params.p_r_o;
				state.params.insulation.leftLean.custom = state.params.p_c_i;
			}
			if (params.add_right_lean) {
				if (const_var.leanGetDataRight && const_var.insulationArrayForLeantoRight.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoRight.insulation_wall = {};
				}
				state.params.insulation.rightLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.rightLean.roofOnly = state.params.p_r_o;
				state.params.insulation.rightLean.custom = state.params.p_c_i;
			}
			if (params.add_back_lean) {
				if (const_var.leanGetDataBack && const_var.insulationArrayForLeantoBack.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoBack.insulation_wall = {};
				}
				state.params.insulation.backLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.backLean.roofOnly = state.params.p_r_o;
				state.params.insulation.backLean.custom = state.params.p_c_i;
			}
			if (state.params.p_f_i == false) {
				state.params.p_i_o = 0;
				if (const_var.a_p_d_a && const_var.cbInsulation != undefined && const_var.cbInsulation.length > 0) {
					state.params.insulation.frontLean.insulationId = 0;
					state.params.insulation.leftLean.insulationId = 0;
					state.params.insulation.rightLean.insulationId = 0;
					state.params.insulation.backLean.insulationId = 0;
				}
				state.const_var.showDefaultInsullation = false;
			}
			if (state.params.p_i_o == 0) {
				state.params.p_i_o = Object.keys(const_var.insulationJson)[0];

				if (const_var.a_p_d_a && const_var.cbInsulation != undefined && const_var.cbInsulation.length > 0) {
					if (params.add_front_lean) {
						state.params.insulation.frontLean.insulationId = state.params.p_i_o;
					}
					if (params.add_left_lean) {
						state.params.insulation.leftLean.insulationId = state.params.p_i_o;
					}
					if (params.add_right_lean) {
						state.params.insulation.rightLean.insulationId = state.params.p_i_o;
					}
					if (params.add_back_lean) {
						state.params.insulation.backLean.insulationId = state.params.p_i_o;
					}
				}
			}

			reRenderVar = action;
			state.const_var.UpdatedPriceData.insulation_price = undefined;
			state.const_var.UpdatedPriceData.insulation_price_changed = true;
			const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
			state.params.selectedInsulationId = state.params.p_i_o;
		}
		if (action.condition == "custom") {
			if (state.params.p_c_i == false) {
				state.params.p_i_o = 0;
				state.params.insulation.frontLean.insulationId = 0;
				state.params.insulation.leftLean.insulationId = 0;
				state.params.insulation.rightLean.insulationId = 0;
				state.params.insulation.backLean.insulationId = 0;

				state.params.insulation.frontLean.fullBuilding = false;
				state.params.insulation.frontLean.roofOnly = false;
				state.params.insulation.frontLean.custom = false;

				state.params.insulation.leftLean.fullBuilding = false;
				state.params.insulation.leftLean.roofOnly = false;
				state.params.insulation.leftLean.custom = false;

				state.params.insulation.rightLean.fullBuilding = false;
				state.params.insulation.rightLean.roofOnly = false;
				state.params.insulation.rightLean.custom = false;

				state.params.insulation.backLean.fullBuilding = false;
				state.params.insulation.backLean.roofOnly = false;
				state.params.insulation.backLean.custom = false;

				if (const_var.post_data?.building?.leanto != undefined && const_var.post_data?.building?.leanto?.length > 0) {
					const_var.post_data?.building?.leanto.forEach((item) => {
						item.insulation_price = undefined;
					});
				}

				if (const_var.insulationPriceJson.insulation_wall != undefined) {
					const_var.insulationPriceJson.insulation_wall = {};
				}
				if (const_var.UpdatedPriceData?.insulation_type?.insulation_wall) {
					const_var.UpdatedPriceData.insulation_type.insulation_wall = undefined;
				}
				if (const_var.UpdatedPriceData?.leanto && const_var.UpdatedPriceData.leanto.length > 0) {
					const_var.UpdatedPriceData.leanto.forEach((obj) => {
						if (obj && obj.insulation_type?.insulation_wall) {
							obj.insulation_type.insulation_wall = {};
						}
					});
				}
				if (const_var.insulationArrayForLeantoFront.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoFront.insulation_wall = {};
				}
				if (const_var.insulationArrayForLeantoBack.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoBack.insulation_wall = {};
				}
				if (const_var.insulationArrayForLeantoLeft.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoLeft.insulation_wall = {};
				}
				if (const_var.insulationArrayForLeantoRight.insulation_wall != undefined) {
					const_var.insulationArrayForLeantoRight.insulation_wall = {};
				}
			}
			state.params.p_c_i = action.isInsChange == true ? state.params.p_c_i : !state.params.p_c_i;
			state.params.p_r_o = false;
			state.params.p_f_i = false;
			if (params.add_front_lean) {
				state.params.insulation.frontLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.frontLean.roofOnly = state.params.p_r_o;
				state.params.insulation.frontLean.custom = state.params.p_c_i;
			}
			if (params.add_left_lean) {
				state.params.insulation.leftLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.leftLean.roofOnly = state.params.p_r_o;
				state.params.insulation.leftLean.custom = state.params.p_c_i;
			}
			if (params.add_right_lean) {
				state.params.insulation.rightLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.rightLean.roofOnly = state.params.p_r_o;
				state.params.insulation.rightLean.custom = state.params.p_c_i;
			}
			if (params.add_back_lean) {
				state.params.insulation.backLean.fullBuilding = state.params.p_f_i;
				state.params.insulation.backLean.roofOnly = state.params.p_r_o;
				state.params.insulation.backLean.custom = state.params.p_c_i;
			}
			if (state.params.p_c_i == false) {
				state.params.p_i_o = 0;
				if (const_var.a_p_d_a && const_var.cbInsulation != undefined && const_var.cbInsulation.length > 0) {
					state.params.insulation.frontLean.insulationId = 0;
					state.params.insulation.leftLean.insulationId = 0;
					state.params.insulation.rightLean.insulationId = 0;
					state.params.insulation.backLean.insulationId = 0;
				}
				state.const_var.showDefaultInsullation = false;
			}
			if (state.params.p_i_o == 0) {
				state.params.p_i_o = Object.keys(const_var.insulationJson)[0];

				if (const_var.a_p_d_a && const_var.cbInsulation != undefined && const_var.cbInsulation.length > 0 && const_var.insulationJsonLeanTo) {
					if (params.add_front_lean) {
						state.params.insulation.frontLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0];
					}
					if (params.add_left_lean) {
						state.params.insulation.leftLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0];
					}
					if (params.add_right_lean) {
						state.params.insulation.rightLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0];
					}
					if (params.add_back_lean) {
						state.params.insulation.backLean.insulationId = Object.keys(const_var.insulationJsonLeanTo)[0];
					}
				}
			}
			reRenderVar = action;
			if (params.add_front_lean) {
				const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
				cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
			}
			if (params.add_left_lean) {
				const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
				cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
			}
			if (params.add_right_lean) {
				const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
				cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
			}
			if (params.add_back_lean) {
				const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
				cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
			}
			state.const_var.UpdatedPriceData.insulation_price = undefined;
			state.const_var.UpdatedPriceData.insulation_price_changed = true;
			const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
			state.params.selectedInsulationId = state.params.p_i_o;
		}
	}
	if (action.condition == "trussUpgrade") {
		state.params.p_t_u = action.value;
		reRenderVar = action.condition + state.params.p_t_u;
	}

	if (action.condition == "extraTruss") {
		state.params.p_e_t = action.value;
		reRenderVar = action.condition + state.params.p_e_t;
	}
	if (action.condition == "peakbraces") {
		state.params.p_p_b = action.value;
		reRenderVar = action.condition + state.params.p_p_b;
	}
	if (action.condition == "extraBows") {
		state.params.p_e_b = action.value;
		reRenderVar = action.condition + state.params.p_e_b;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.common_height_changed = true;
	}
	if (action.condition == "concreteAnchors") {
		state.params.p_a_ch = action.value;
		reRenderVar = action.condition + state.params.p_a_ch;
	}
	if (action.condition == "mobileAnchors") {
		state.params.p_m_h_a = action.value;
		reRenderVar = action.condition + state.params.p_m_h_a;
	}
	if (action.condition == "asphaltAnchors") {
		state.params.p_r_a = action.value;
		reRenderVar = action.condition + state.params.p_r_a;
	}

	if (action.condition == "scbracing") {
		state.params.p_s_c_b = action.value != "none" ? true : false;
		reRenderVar = action;
		state.const_var.UpdatedPriceData.common_length_changed = true;
		state.const_var.selected_scbracing = action.value || "none";
		cuBuilding.BuildingUpdate(true);
	}
	if (action.condition == "left-scbracing") {
		state.params.added_building_bracing.p_s_c_b_l = action.value != "none" ? true : false;
		reRenderVar = action;
		state.const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		const_var.selectedBracingForAddedBuilding.left_lean_side = action.value || "none";
		if (const_var.LNTCrossBracing["left"]["Side Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["left"]["Side Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateLeftLean();
	}
	if (action.condition == "right-scbracing") {
		state.params.added_building_bracing.p_s_c_b_r = action.value != "none" ? true : false;
		reRenderVar = action;
		state.const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		const_var.selectedBracingForAddedBuilding.right_lean_side = action.value || "none";
		if (const_var.LNTCrossBracing["right"]["Side Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["right"]["Side Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateRightLean();
	}
	if (action.condition == "front-scbracing") {
		state.params.added_building_bracing.p_s_c_b_f = action.value != "none" ? true : false;
		reRenderVar = action;
		state.const_var.UpdatedPriceData.common_front_lean_length_changed = true;
		const_var.selectedBracingForAddedBuilding.front_lean_side = action.value || "none";
		if (const_var.LNTCrossBracing["front"]["Side Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["front"]["Side Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateFrontLean();
	}
	if (action.condition == "back-scbracing") {
		state.params.added_building_bracing.p_s_c_b_b = action.value != "none" ? true : false;
		reRenderVar = action;
		state.const_var.UpdatedPriceData.common_back_lean_length_changed = true;
		const_var.selectedBracingForAddedBuilding.back_lean_side = action.value || "none";
		if (const_var.LNTCrossBracing["back"]["Side Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["back"]["Side Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateBackLean();
	}

	if (action.condition == "ecbracing") {
		state.params.p_e_c_b = action.value != "none" ? true : false;
		reRenderVar = action;

		state.const_var.UpdatedPriceData.common_width_changed = true;
		state.const_var.selected_ecbracing = action.value || "none";
		cuBuilding.BuildingUpdate(true);
	}
	if (action.condition == "left-ecbracing") {
		state.params.added_building_bracing.p_e_c_b_l = action.value != "none" ? true : false;
		reRenderVar = action;

		state.const_var.UpdatedPriceData.common_left_lean_width_changed = true;
		const_var.selectedBracingForAddedBuilding.left_lean_end = action.value || "none";
		if (const_var.LNTCrossBracing["left"]["End Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["left"]["End Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateLeftLean();
	}
	if (action.condition == "right-ecbracing") {
		state.params.added_building_bracing.p_e_c_b_r = action.value != "none" ? true : false;
		reRenderVar = action;

		state.const_var.UpdatedPriceData.common_right_lean_width_changed = true;
		state.const_var.selectedBracingForAddedBuilding.right_lean_end = action.value || "none";
		if (const_var.LNTCrossBracing["right"]["End Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["right"]["End Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateRightLean();
	}
	if (action.condition == "front-ecbracing") {
		state.params.added_building_bracing.p_e_c_b_f = action.value != "none" ? true : false;
		reRenderVar = action;

		state.const_var.UpdatedPriceData.common_front_lean_width_changed = true;
		state.const_var.selectedBracingForAddedBuilding.front_lean_end = action.value || "none";
		if (const_var.LNTCrossBracing["front"]["End Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["front"]["End Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateFrontLean();
	}
	if (action.condition == "back-ecbracing") {
		state.params.added_building_bracing.p_e_c_b_b = action.value != "none" ? true : false;
		reRenderVar = action;

		state.const_var.UpdatedPriceData.common_back_lean_width_changed = true;
		state.const_var.selectedBracingForAddedBuilding.back_lean_end = action.value || "none";
		if (const_var.LNTCrossBracing["back"]["End Cross Bracing"] != undefined) {
			const_var.LNTCrossBracing["back"]["End Cross Bracing"] = undefined;
		}
		cuBuilding.UpdateBackLean();
	}
	if (action.condition == "overhangUpdate" && action.nextVal != "") {
		updateOverHang(action, state);
		reRenderVar = Math.random() + action;
	}
	if (const_var.c_f_a_per[params.p_e_i] != 0 && params.p_e_i != "other") {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	const_var.UpdatedPriceData.surcharge_amount = undefined;

	cuBuilding.cP();

	return {
		...state,
		newColor: reRenderVar
	};
};
export const handleExtraInformation = (state, action) => {
	let reRenderInfo = "";
	if (action.condition == "jobsite") {
		if (action.value.target.value == "" || action.value.target.value == "no") {
			state.params.job_site_level = "yes";
		} else {
			state.params.job_site_level = "no";
		}

		reRenderInfo = action.condition + state.params.p_j_l + state.params.job_site_level;
	}
	if (action.condition == "notes") {
		state.params.additional_note = action.value;
		reRenderInfo = action.condition + state.params.additional_note;
	}
	if (action.condition == "power") {
		if (action.value.target.value == "" || action.value.target.value == "no") {
			state.params.power_avail = "yes";
		} else {
			state.params.power_avail = "no";
		}
		reRenderInfo = action.condition + state.params.p_p_a + state.params.power_avail;
	}
	return {
		...state,
		newColor: reRenderInfo
	};
};
export const handleSurfaceChange = (state, action, utils) => {
	let checkOverHeadDoor = const_var.entry_points.find((s) => s.child_array_key.includes("overhead_door_door"));
	const_var.installation_surface = action.value;
	if (state.params.m_s_n == 33 && checkOverHeadDoor !== undefined && action.value != 1 && const_var.installationsurfaceChange == true) {
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "changeInstallationSurface";
	} else {
		state.params.p_i_s = action.value;
		if (state.params.m_s_n == 11 || state.params.m_s_n == 54 || state.params.m_s_n == 147 || state.params.m_s_n == 160) {
			const_var.isCheckGroundCertificate = true;
			utils.surfaceCertificateApplied(state);
		}
		utils.installationSurface(state.params.p_i_s);
		if (const_var.post_data["building"] != undefined) {
			const_var.post_data["building"].installation_surface = const_var.installationValue[params.p_i_s].toLowerCase();
		}
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (params.add_left_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
		}
		if (params.add_front_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
		}
		if (params.add_back_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
		}
		if (params.add_right_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
		}
		cuBuilding.cP();
	}
	return {
		...state,
		action,
		newColor: action.value
	};
};

export const handleAddAdditionComponent = (state, action) => {
	const updatedPriceElements = const_var.isLTBuilding ? const_var.lNTBuildingData.updatePriceDataElements.centerBuilding : const_var.UpdatedPriceData.elements;

	if (action.condition == "additionalComponent" && action.nextVal != "") {
		state.const_var.inputs[action.index] = action.nextVal;
		if (action.value.trim() != "" && action.indexName == "additional_name") {
			let holdOldResp = updatedPriceElements?.[state.const_var.inputs[action.index].additional_name];
			if (holdOldResp) {
				delete updatedPriceElements[state.const_var.inputs[action.index].additional_name];
				updatedPriceElements[action.value] = holdOldResp;
				updatedPriceElements[action.value].item_name = action.value;
				state.const_var.inputs[action.index].additional_name = action.value;
			}
		}
		if (action.indexName == "additional_name") {
			if (action.value != "") {
				state.const_var.inputs[action.index].additional_name = action.value;
			} else {
				state.const_var.inputs[action.index].additional_name = action.value;
				state.const_var.inputs[action.index].additional_quantity = 0;
			}

			cuBuilding.cP();
		} else {
			state.const_var.inputs[action.index].additional_quantity = isNaN(parseInt(action.value)) == true ? 0 : parseInt(action.value);
			cuBuilding.cP();
		}
	}
	return {
		...state,
		AdditionComponentAdd: state.const_var.inputs[action.index].additional_name + state.const_var.inputs[action.index].additional_quantity + action.value + action.condition
	};
};
export const handleNewComponent = (state, action) => {
	const updatedPriceElements2 = const_var.isLTBuilding ? const_var.lNTBuildingData.updatePriceDataElements.centerBuilding : const_var.UpdatedPriceData.elements;
	if (action.condition == "addNewComponent" && action.nextVal != "") {
		state.const_var.Componentinputs[action.index] = action.nextVal;
		if (action.value.trim() != "" && action.indexName == "additional_name") {
			let holdOldResp = updatedPriceElements2?.[state.const_var.Componentinputs[action.index].additional_name];
			if (holdOldResp) {
				delete updatedPriceElements2[state.const_var.Componentinputs[action.index].additional_name];
				updatedPriceElements2[action.value] = holdOldResp;
				updatedPriceElements2[action.value].item_name = action.value;
				state.const_var.Componentinputs[action.index].additional_name = action.value;
			}
		}
		if (action.indexName == "additional_name") {
			if (action.value != "") {
				state.const_var.Componentinputs[action.index].additional_name = action.value;
			} else {
				state.const_var.Componentinputs[action.index].additional_name = action.value;
				state.const_var.Componentinputs[action.index].additional_quantity = 0;
			}
			cuBuilding.cP();
		} else {
			state.const_var.Componentinputs[action.index].additional_quantity = isNaN(parseInt(action.value)) == true ? 0 : parseInt(action.value);
			cuBuilding.cP();
		}
	}
	return {
		...state,
		AdditionComponentAdd: state.const_var.Componentinputs[action.index].additional_name + state.const_var.Componentinputs[action.index].additional_quantity + action.value + action.condition
	};
};
export const handleCertificateChange = (state, action) => {
	utils.update26GAUpgradePrice();
	if (params.add_left_lean && const_var.isLTBuilding && params.leanStyle.left === "gable") {
		utils.update26GAUpgradePrice("left");
	}
	if (params.add_right_lean && const_var.isLTBuilding && params.leanStyle.right === "gable") {
		utils.update26GAUpgradePrice("right");
	}
	if (params.add_front_lean && const_var.isLTBuilding && params.leanStyle.front === "gable") {
		utils.update26GAUpgradePrice("front");
	}
	if (params.add_back_lean && const_var.isLTBuilding && params.leanStyle.back === "gable") {
		utils.update26GAUpgradePrice("back");
	}
	let updatePriceDataElements = const_var.UpdatedPriceData["elements"];
	let a_p_d_aa = const_var.a_p_d_a;
	let ExtraItemsFeaturesArray = const_var.ExtraItemsFeaturesArray;
	let ExtraItemsFeaturesQuantityArray = const_var.ExtraItemsFeaturesQuantityArray;
	if (const_var.isLTBuilding) {
		updatePriceDataElements = const_var.lNTBuildingData.updatePriceDataElements.centerBuilding;
		a_p_d_aa = JSON.parse(JSON.stringify(const_var.holdPricingResponse));
		ExtraItemsFeaturesArray = const_var.lNTBuildingData.ExtraItemsFeaturesArray["centerBuilding"];
		ExtraItemsFeaturesQuantityArray = const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray["centerBuilding"];
	}
	let tempDefaultDistanceOnCenter = JSON.parse(JSON.stringify(const_var.defaultDistanceOnCenter));
	if (params.m_s_n == 87 || params.m_s_n == 8 || params.m_s_n == 121 || params.m_s_n == 181 || params.m_s_n == 17) {
		const_var.lNTBuildingData?.ExtraItemsFeaturesQuantityArray &&
			Object.entries(const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray)?.forEach(([key, val]) => {
				val?.forEach((item, bowsIndex) => {
					if (item && item?.name == "bows" && item?.is_checked) {
						if (const_var.lNTBuildingData.updatePriceDataElements[key][item.label]) {
							const_var.lNTBuildingData.updatePriceDataElements[key][item.label].is_edit = false;
							const_var.lNTBuildingData.updatePriceDataElements[key][item.label].is_disabled = false;
						}
						const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray[key][bowsIndex].is_disabled = false;
						const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray[key][bowsIndex].is_edit = false;
					}
				});
			});
	}
	utils.setLNTBuildingData("certificate", action.value);

	if (action.str == "center") {
		let exactNum = 0;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		if (params.p_f_w !== "Close" && params.p_f_w !== "Open" && params.p_f_w !== "Half_Close" && params.p_f_w !== "One_Fourth_Close" && params.p_f_w !== "Three_Fourth_Close") {
			const_var.UpdatedPriceData.front_wall_price_changed = true;
		}
		if (params.p_b_w !== "Close" && params.p_b_w !== "Open" && params.p_b_w !== "Half_Close" && params.p_b_w !== "One_Fourth_Close" && params.p_b_w !== "Three_Fourth_Close") {
			const_var.UpdatedPriceData.back_wall_price_changed = true;
		}
		if (action.other != undefined) {
			state.params.p_e_i_other = action.value;
		} else {
			state.params.p_e_i = action.value;
			state.params.p_e_i_other = "";
		}
		let chkDistance = const_var.c_f_aCer.find((data) => data && data.distance_on_center == 4);
		if (chkDistance != undefined && action.other == undefined && action.value != "other" && action.value != "Select") {
		} else {
			if (const_var.crmSetting.is_Edit != true) {
				if (params.fourth_center_cost == true || (const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4)) {
					const_var.DistanceArr[params.p_b_t][params.p_r_s] =
						action.value != "other" && action.value != "Select" ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : const_var.a_p_d_a.building_structure[0]?.distance_on_center;
					let is4ftChecked = false;
					if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 && action.value != "other" && action.value != "Select") {
						is4ftChecked = true;
						params.fourth_center_cost = true;
					}
					if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == 5) {
						params.isDefaultfourFeet = params.fourth_center_cost = false;
						if (!params.isBreezeway) {
							if (state.params.p_u_c) {
								state.params.p_u_t =
									Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
							}
							cuBuilding.uUdD();
						} else {
							makeDimensionArray(state);
							updateBreezewayFrameAndStorages({ option: "buildingLength" }, undefined, Number(params.p_h), Number(params.p_d));
						}
						cuBuilding.leanuUdD();
						cuBuilding.BuildingUpdate(true, "");
						if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
						if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
						if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
						if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
						if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront, "frontLean");
						if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft, "leftLean");
						if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight, "rightLean");
						if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack, "backLean");
						if (const_var.entry_points.length > 0) {
						}
					}
				}

				if (params.fourth_center_cost || const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4) {
					if (params.add_front_lean) {
						if (const_var.leanGetDataFront != undefined) {
							if (const_var.leanGetDataFront.building_structure.distance_on_center != 4) {
								calculateLegsCount(const_var.leanGetDataFront, "frontLean");
							}
						}
					}
					if (params.add_left_lean) {
						if (const_var.leanGetDataLeft != undefined) {
							if (const_var.leanGetDataLeft.building_structure.distance_on_center != 4) {
								calculateLegsCount(const_var.leanGetDataLeft, "leftLean");
							}
						}
					}
					if (params.add_right_lean) {
						if (const_var.leanGetDataRight != undefined) {
							if (const_var.leanGetDataRight.building_structure.distance_on_center != 4) {
								calculateLegsCount(const_var.leanGetDataRight, "rightLean");
							}
						}
					}
					if (params.add_back_lean) {
						if (const_var.leanGetDataBack != undefined) {
							if (const_var.leanGetDataBack.building_structure.distance_on_center != 4) {
								calculateLegsCount(const_var.leanGetDataBack, "backLean");
							}
						}
					}
				}
			}
			cuBuilding.cP();
		}

		if (params.add_left_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforLLeanOnly(state.const_var.leanGetDataLeft);
		}
		if (params.add_right_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforRLeanOnly(state.const_var.leanGetDataRight);
		}
		if (params.add_front_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforFLeanOnly(state.const_var.leanGetDataFront);
		}
		if (params.add_back_lean == true) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
			cuBuilding.cPforBLeanOnly(state.const_var.leanGetDataBack);
		}
	}
	if (action.str == "left") {
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (action.other != undefined) {
			state.params.lean_p_e_i_other = action.value;
		} else {
			state.params.lean_p_e_i = action.value;
			state.params.lean_p_e_i_other = "";
		}
		cuBuilding.cPforLLeanOnly(state.const_var.leanGetDataLeft);
	}
	if (action.str == "front") {
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (action.other != undefined) {
			state.params.leanF_p_e_i_other = action.value;
		} else {
			state.params.leanF_p_e_i = action.value;
			state.params.leanF_p_e_i_other = "";
		}
		cuBuilding.cPforFLeanOnly(state.const_var.leanGetDataFront);
	}
	if (action.str == "back") {
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (action.other != undefined) {
			state.params.leanB_p_e_i_other = action.value;
		} else {
			state.params.leanB_p_e_i = action.value;
			state.params.leanB_p_e_i_other = "";
		}
		cuBuilding.cPforBLeanOnly(state.const_var.leanGetDataBack);
	}
	if (action.str == "right") {
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (action.other != undefined) {
			state.params.leanR_p_e_i_other = action.value;
		} else {
			state.params.leanR_p_e_i = action.value;
			state.params.leanR_p_e_i_other = "";
		}
		cuBuilding.cPforRLeanOnly(state.const_var.leanGetDataRight);
	}

	return {
		...state,
		newColor: action.str + new Date().getTime(),
		action
	};
};
export const extraAddOnFormulaCal = (actionIndex, itemArray = const_var.extraAddOnItemsArray, callFor = "", isCompare = false) => {
	let currW = params.p_w;
	let currH = params.p_h;
	let currL = params.p_d;

	if (callFor == "frontLean") {
		currW = params.leanF_p_w;
		currH = params.leanF_p_h;
		currL = params.leanF_p_d;
		let leanData = const_var.post_data.building.leanto.find((lean) => lean.leanto_type == 3);
		if ((params.add_right_front_lean_porch == true || params.add_left_front_lean_porch == true) && leanData?.wrappedLength) {
			currL = parseFloat(leanData.wrappedLength || params.leanF_p_d);
		}
	} else if (callFor == "backLean") {
		currW = params.leanB_p_w;
		currH = params.leanB_p_h;
		currL = params.leanB_p_d;
		let leanData = const_var.post_data.building.leanto.find((lean) => lean.leanto_type == 4);
		if ((params.add_right_back_lean_porch == true || params.add_left_back_lean_porch == true) && leanData?.wrappedLength) {
			currL = parseFloat(leanData.wrappedLength || params.leanB_p_d);
		}
	} else if (callFor == "rightLean") {
		currW = params.leanR_p_w;
		currH = params.leanR_p_h;
		currL = params.leanR_p_d;
		let leanData = const_var.post_data.building.leanto.find((lean) => lean.leanto_type == 2);
		if ((params.add_right_front_lean_porch == true || params.add_right_back_lean_porch == true) && leanData?.porch?.length) {
			currL = parseFloat(leanData.porch?.length || params.leanR_p_d);
		}
	} else if (callFor == "leftLean") {
		currW = params.lean_p_w;
		currH = params.lean_p_h;
		currL = params.lean_p_d;
		let leanData = const_var.post_data.building.leanto.find((lean) => lean.leanto_type == 1);
		if ((params.add_left_front_lean_porch == true || params.add_left_back_lean_porch == true) && leanData?.porch?.length) {
			currL = parseFloat(leanData.porch?.length || params.lean_p_d);
		}
	}
	if (itemArray[actionIndex]?.name?.includes("loft") && itemArray[actionIndex]?.is_checkbox && itemArray[actionIndex]?.is_checkbox == 2) {
		let isFor = "center";
		if (const_var.isLTBuilding) {
			isFor =
				callFor == "frontLean" && params.leanStyle["front"] == "gable"
					? "front"
					: callFor == "backLean" && params.leanStyle["back"] == "gable"
						? "back"
						: callFor == "rightLean" && params.leanStyle["right"] == "gable"
							? "right"
							: callFor == "leftLean" && params.leanStyle["left"] == "gable"
								? "left"
								: "center";
		}
		currL = const_var.selLoftVal[isFor];
	}
	if (itemArray[actionIndex]?.formula && Object.entries(itemArray[actionIndex]?.formula).length > 0) {
		let extraAddOnSum = Object.values(itemArray[actionIndex].formula).map((item) => {
			const expr = item
				.replace(/\bWidth\b/gi, currW)
				.replace(/\bHeight\b/gi, currH)
				.replace(/\bLength\b/gi, currL)
				.replace(/\bx\b/gi, "*");

			try {
				return Function(`"use strict"; return (${expr})`)();
			} catch {
				return 0;
			}
		});
		const costSum = extraAddOnSum.reduce((sum, val) => sum + val, 0);
		if (itemArray[actionIndex].main_cost == undefined) {
			itemArray[actionIndex]["main_cost"] = itemArray[actionIndex].cost;
		}
		itemArray[actionIndex].cost = parseFloat(costSum) * parseFloat(itemArray[actionIndex].main_cost);
	}
	if (isCompare) {
		return itemArray[actionIndex].cost;
	}
};